import "../ext_libs/select2/select2.js";

import "../scripts/global/util.js";
import "../scripts/global/ReferralUtils.js";
import "../scripts/global/HFile.js";
import "../scripts/global/GoogleCountryCodes.js";
import "../scripts/global/PerformanceUtils.js";
import "../scripts/global/color.utils.js";
import "../scripts/global/brand-tree.utils.js";
import "../scripts/config/environments.config.js";
import "../root.app.js";
import "../scripts/app.js";

import "../scripts/config/search.conf.js";
import "../scripts/config/public.conf.js";

import "../scripts/storage-policy/h-local-storage-store.js";
import "../scripts/storage-policy/h-memory-store.js";
import "../scripts/storage-policy/h-cookies-store.js";
import "../scripts/storage-policy/h-session-store.js";
import "../scripts/storage-policy/h-storage-manager.js";
import "../scripts/storage-policy/h-third-party-manager.js";

import "../scripts/global/MediaUtils.js";
import "../scripts/global/DocUtils.js";
import "../scripts/global/JarEventEmitter.js";
import "../scripts/global/h-buffer.js";
import "../scripts/global/h-recaptcha.util.js";
import "../scripts/global/h-transition.service.js";
import "../scripts/global/h-weather.service.js";
import "../hmodules/harri-main/services/cache.service.js";

import "../scripts/i18nModule.js";
import "../scripts/dispatcherModule.js";

import "../scripts/ngTemplates.js";

import "../scripts/loginManager/MsgBus.js";
import "../scripts/loginManager/HLoginManager.js";

import "../apis/BaseAPI.js";

import "../modules/hforms/ob_custom_documents_form/OBCustomDocumentsForm.js";
import "../modules/hforms/general/scripts/BaseForm.js";
import "../modules/hforms/general/scripts/FormGroup.js";
import "../modules/hforms/general/scripts/FormValidator.js";
import "../modules/forms/scripts/formsDirectives.js";
import "../scripts/services/resume.js";

import "../scripts/globalFactories/isMobile.js";

import "../scripts/services/asyncGlobalHandler.js";
import "../scripts/services/hEvent.js";
import "../scripts/globalFactories/httpHelper.js";

import "../scripts/global/globalFilters.js";
import "../scripts/nunjucksWrapper.js";
import "../scripts/_templates.js";

import "../apis/AMSAPI.js";
import "../apis/TeamAPI.js";
import "../apis/BrandAPI.js";
import "../apis/CoreReaderAPI.js";
import "../apis/EmployeeBenefitsAPI.js";
import "../apis/TeamImportAPI.js";
import "../apis/AttendanceAPI.js";
import "../apis/UserAPI.js";
import "../apis/TeamScheduleAPI.js";
import "../apis/TeamScheduleV2API.js";
import "../apis/TSAvailabilityAPI.js";
import "../apis/SocialReferralAPI.js";
import "../apis/NotificationCenterAPI.js";
import "../apis/NotificationCenterAPIV2.js";
import "../apis/LogbookAPI.js";
import "../apis/WOTCAPI.js";
import "../apis/CountriesAPI.js";
import "../apis/SatisfactionAPI.js";
import "../apis/WelcomeStatusAPI.js";
import "../apis/ApprovalFlowAPI.js";

import "../apis/TeamCommunicationAPI.js";
import "../apis/TeamScheduleUserAPI.js";
import "../apis/InteractionsAPI.js";
import "../apis/PerformanceAggregatorAPI.js";
import "../apis/MiceAPI.js";
import "../apis/PerformanceStatsAPI.js";
import "../apis/BackgroundCheckAPI.js";
import "../apis/RightToWorkAPI.js";
import "../apis/GlobalSearchAPI.js";
import "../apis/AQAAFAPI.js";
import "../apis/TeamLiveReportsAPI.js";
import "../apis/ComplianceTrainingAPI.js";
import "../apis/LMSFollowUpAPI.js";
import "../apis/TeamLiveScheduleBudgetingAPI.js";
import "../apis/MinorSchedulingAPI.js";
import "../apis/TimeKeepingAlertsAPI.js";
import "../apis/ExternalTipProviderAPI.js";
import "../apis/RecognitionAPI.js";
import "../apis/GatewayTeamLiveAPI.js";
import "../apis/GatewayAPI.js";
import "../apis/CarriAPI.js";
import "../apis/PreHireAPI.js";
import "../apis/DataPassAPI.js";
import "../apis/AccountManagementAPI.js";
import "../apis/GoodFaithEstimateAPI.js";
import "../apis/DashboardAPI.js";
import "../apis/SettingsAPI.js";
import "../apis/LMSAPI.js";
import "../apis/LightSignUpAPI.js";
import "../apis/WendysLaborAPI.js";
import "../apis/TeamLiveShiftOfferFinancialsApi.js";
import "../apis/CarrolLaborAPI.js";
import "../apis/McDLaborAPI.js";
import "../apis/GastronomyLaborAPI.js";
import "../apis/VersionManagerAPI.js";
import "../apis/EmployeeClockStatsAPI.js";
import "../apis/HumanResourceActionsAPI.js";
import "../apis/UserTrackingManagerAPI.js";
import "../apis/IndeedCampaignsAPI.js";
import "../apis/CognitoUserManagerAPI.js";
import "../apis/GifsAPI.js";

import "../modules/dom-observer/DomMutationObserver.js";

import "../modules/forms/scripts/customizedDirectives.js";
import "../modules/forms/components/customControls/CustomControls.js";
import "../modules/forms/components/coolAutocomplete/coolautocomplete.js";
import "../modules/forms/components/confirmation/confirmation.js";
import "../modules/forms/components/monthDatePicker/monthDatePicker.js";
import "../modules/forms/components/datePicker/DatePicker.js";
import "../modules/forms/components/dateRangePicker/DateRangePicker.js";

import "../scripts/global-directives/scripts/globalDirectives.js";
import "../scripts/global-directives/scripts/hSlider.js";
import "../scripts/global-directives/scripts/hWeekDatePicker.js";
import "../scripts/global-directives/scripts/hDayDatePicker.js";
import "../modules/team_schedule/common/scripts/TSUtils.js";
import "../modules/team_schedule/common/scripts/TeamCommunicationService.js";
import "../modules/team_schedule/common/scripts/TSFilters.js";

import "../scripts/global-directives/scripts/hMonthPicker.js";

import "../modules/team_schedule/common/scripts/TSHeaderOneDirective.js";


import "../modules/team_schedule/common/scripts/TeamScheduleService.js";
import "../modules/team_schedule/common/scripts/TeamService.js";
import "../modules/team_schedule/common/scripts/business-day-utils.service.js";
import "../modules/team_schedule/common/scripts/employee-satisfaction.service.js";

import "../modules/team_schedule/common/scripts/TSSideBarService.js";
import "../modules/team_schedule/common/scripts/TSPullingService.js";
import "../modules/team_schedule/common/scripts/TSMediaViewerService.js";
import "../modules/team_schedule/common/scripts/TSMediaViewerDirective.js";
import "../modules/team_schedule/common/scripts/TSUsersService.js";
import "../modules/team_schedule/common/scripts/ScheduleController.js";
import "../modules/team_schedule/common/scripts/TSToastService.js";

import "../modules/team_schedule//employer/schedule/utils/shiftTemplateUtils.js";

import "../modules/team_schedule/common/scripts/TSTeamWallDirective.js";

import "../modules/forms/scripts/imageCropping.js";
import "../scripts/apis/userMediaApi.js";

import "../modules/scheduler/scripts/SchedulerDragDropService.js";
import "../modules/team_schedule/employer/schedule/scripts/AssignEmployeesSelect.js";
import "../hmodules/team-live/availability-requests/services/availability-data.service.js";

import "../modules/scheduler_v2/scripts/ScheduleDataServiceV2.js";
import "../modules/scheduler_v2/scripts/ScheduleWarningServiceV2.js";
import "../modules/scheduler_v2/scripts/schedule-differential-pay-service.js";
import "../modules/scheduler_v2/scripts/ScheduleCostsServiceV2.js";
import "../modules/scheduler_v2/scripts/minor-scheduling.service.js";
import "../modules/scheduler_v2/scripts/fair-scheduling.service.js";
import "../modules/scheduler_v2/scripts/schedule-date-utils.service.js";
import "../modules/scheduler_v2/scripts/auto-scheduling.service.js";
import "../modules/scheduler_v2/scripts/good-faith-estimate.service.js";
import "../modules/scheduler_v2/scripts/just-cause.service.js";
import "../modules/scheduler_v2/scripts/rest-between-days.service.js";

import "../modules/scheduler_v2/scripts/ApprovedRequestsDataService.js";

import "../modules/forms/scripts/googleMaps.js";


import "../scripts/global-directives/header-links-preferences-modal/header-links-preferences.modal.js";
import "../scripts/global/header-items.service.js";

import "../scripts/global-directives/header/HeaderDirective.js";
import "../scripts/global-directives/global_search/GlobalSearchDirective.js";
import "../scripts/global-directives/global_search_result_directive/GlobalSearchResultDirective.js";
import "../scripts/global-directives/global_search/GlobalSearchDataManager.js";
import "../scripts/global-directives/enhanced_strap_select/EnhancedStrapSelectDirective.js";
import "../modules/team_schedule/common/scripts/EmployeeProfileDirective.js";

import "../modules/team_schedule/common/timesheet/CTTimesheetService.js";
import "../modules/team_schedule/employer/clock_time/timesheet/services/timesheet-settings.service.js";
import "../modules/team_schedule/employer/settings/services/tl-employer-settings-data.service.js";
import "../modules/team_schedule/employer/clock_time/services/employerPaySheet.service.js";
import "../modules/team_schedule/candidate/home/scripts/loginConstants.js";

import "../modules/notifications/scripts/HNotifications.js";

import "../modules/smart-fields/smart-fields.js";
import "../modules/smart-fields/components/at-who-wrapper/at-who-wrapper.js";
import "../modules/smart-fields/components/searchable-items/searchable-items.js";


import "../modules/ie11page/scripts/ie11page.modal.js";

import "../hmodules/components/components.module.js";
import "../hmodules/components/h-tabs/tabs-bar/tabs-bar.component.js";
import "../hmodules/components/h-tabs/tab-item/tab-item.component.js";
import "../hmodules/components/h-file-chooser/file-chooser.component.js";
import "../hmodules/components/h-select-list/h-select-list.component.js";
import "../hmodules/components/h-select-list-async/h-select-async.component.js";
import "../hmodules/components/h-brand-navigator/h-brand-navigator.component.js";
import "../hmodules/components/h-brands-list/h-brands-list.component.js";
import "../hmodules/components/h-nunjucks/h-nunjucks.component.js";
import "../hmodules/components/h-multi-level-selector/h-multi-level-selector.component.js";
import "../hmodules/components/h-rich-text/h-rich-text.component.js";
import "../hmodules/components/h-multi-step-navigator/h-multi-step-navigator.component.js";
import "../hmodules/components/h-date-range-picker/h-date-range-picker.component.js";
import "../hmodules/components/h-color-selector/h-color-selector.component.js";
import "../hmodules/components/h-charts/h-charts.component.js";
import "../hmodules/components/h-icon-picker/h-icon-picker.component.js";
import "../hmodules/components/h-icon-picker/services/icon-picker.service.js";
import "../hmodules/components/h-icon-dropdown/h-icon-dropdown.component.js";
import "../hmodules/components/h-icon-picker/factories/use-icon-picker.factory.js";
import "../hmodules/components/h-categories-positions/h-categories-positions.component.js";
import "../hmodules/components/h-simple-pagination/h-simple-pagination.component.js";
import "../hmodules/components/h-timepicker/h-timepicker.component.js";
import "../hmodules/components/h-timepicker/h-timepicker-wrapper.component.js";
import "../hmodules/components/h-timepicker/h-timepicker.utils.js";
import "../hmodules/components/h-progress-bar/h-progress-bar.component.js";

import "../hmodules/components/h-emojis/Emojis.js";
import "../hmodules/components/h-emojis/h-emoji-list/h-emoji-list.component.js";
import "../hmodules/components/h-emojis/h-emoji-selector/h-emoji-selector.component.js";

import "../hmodules/components/h-gifs/h-gif-list/h-gif-list.component.js";
import "../hmodules/components/h-gifs/h-gif-selector/h-gif-selector.component.js";

import "../hmodules/components/h-navbar-menu/h-navbar-menu.component.js";
import "../hmodules/components/h-numeric-input/h-numeric-input.component.js";

import "../hmodules/directives/directives.module.js";
import "../hmodules/directives/h-header-user-icon/h-header-user-icon.directive.js";
import "../hmodules/directives/h-ts-header-user-icon/h-ts-header-user-icon.directive.js";
import "../hmodules/directives/h-home-access-portal-button/h-home-access-portal-button.directive.js";
import "../hmodules/directives/h-infinte-scroll/h-infinte-scroll.js";
import "../hmodules/directives/h-lazy-load/h-lazy-load.directive.js";
import "../hmodules/directives/copy-to-clipboard/copy-to-clipboard.directive.js";
import "../hmodules/directives/h-animate-bg/h-animate-bg.directive.js";

import "../hmodules/team-live-requests-management/services/team-live-requests-management-data.service.js";

import "../hmodules/forms-manager/forms-manager.module.js";
import "../hmodules/forms-manager/services/h-forms.service.js";

import "../hmodules/api-manager/api-manager.module.js";
import "../hmodules/api-manager/services/h-api.service.js";

import "../hmodules/harri-main/services/user-services.service.js";
import "../hmodules/harri-main/services/brand-services.service.js";
import "../hmodules/harri-main/services/sms-balance.service.js";
import "../hmodules/harri-main/services/user-permissions.service.js";
import "../hmodules/harri-main/services/css-loader.service.js";
import "../hmodules/harri-main/services/route-dependencies-loader.service.js";
import "../hmodules/harri-main/services/announcements.service.js";
import "../hmodules/barri/services/barri-analytics.service.js";
import "../hmodules/reporting-management/services/reports-prerequisite.service.js";
import "../hmodules/harri-main/services/commshub.service.js";
import "../hmodules/harri-main/services/user-brands-tree.service.js";
import "../hmodules/recruitment-hub/services/recruitment-hub.service.js";
import "../hmodules/harri-main/services/version-manager.service.js";
import "../hmodules/indeed-campaigns/services/indeed-campaigns.service.js";
import "../hmodules/harri-main/services/admins-users.service.js";
import "../hmodules/harri-main/services/accessibility-tools.service.js";

import "../hmodules/harri-main/services/harri-side-bar.service.js";
import "../hmodules/harri-main/services/app-layout-view.service.js";

import "../hmodules/harri-main/services/source-hire-filters-view.service.js";
import "../hmodules/harri-main/services/brand-navigator.service.js";
import "../hmodules/harri-main/services/user-management.services.js";

import "../hmodules/harri-main/directives/h-support-link/h-support-link.directive.js";
import "../hmodules/talent-pool/modals/manage-tags/manage-tags.modal.js";
import "../modules/job_apply/scripts/job-apply.factory.js";

import "../modules/settings/modals/something-went-wrong/something-went-wrong.modal.js";

import "../modules/team_schedule/candidate/time_clock/modals/view_shift_modal/CTViewShiftModalController.js";

import "../scripts/global-directives/h-confirm-modal/h-confirm-modal.js";
import "../scripts/global-directives/h-alert-modal/h-alert-modal.js";
import "../hmodules/harri-main/components/h-modal.component.js";
import "../hmodules/harri-main/controllers/h-modal.controller.js";
import "../hmodules/harri-main/services/h-modal.service.js";

import "../scripts/services/ch-message-transform-utils.js";

import "../ext_libs/fancybox/source/jquery.fancybox.pack.js";
import "../ext_libs/bootstrap-modal-fix/bootstrap-modal-fix.js";


import "../hmodules/harri-main/harri-main.app.js";
import "../hmodules/harri-main/containers/harri-layout/harri-layout.container.js";
import "../hmodules/harri-main/components/app-header/app-header.component.js";
import "../hmodules/harri-main/components/app-side-bar/app-side-bar.component.js";
import "../hmodules/harri-main/components/source-hire-filter/source-hire-filter.component.js";
import "../hmodules/harri-main/components/source-hire-add-filter-dropdown/source-hire-add-filter-dropdown.component.js";

import "../hmodules/harri-main/integrations/hot-jar-tracking.service.js";
import "../hmodules/harri-main/integrations/krt-marketing-tracking.service.js";
import "../hmodules/harri-main/integrations/google-tag-manager-tracking.service.js";

import "../hmodules/harri-main/components/h-image-cropper/h-image-cropper.component.js";
import "../hmodules/harri-main/controllers/image-cropper/h-image-cropper.modal.js";

import "../hmodules/shared/shared.module.js";

import "../scripts/config/harri.routes.conf.js";
import "../wp-pages/wp-pages.routes.js";

import "../hmodules/interview-bank/services/interview-bank-data.service.js";

import "../hmodules/interview-bank/modals/start-interview/start-interview-evaluation.modal.js";

import "../hmodules/brands-predefined-sets/utils/brand-navigator.utils.js";
import "../hmodules/brands-predefined-sets/services/brands-predefined-sets.service.js";
import "../hmodules/brands-predefined-sets/modals/brands-predefined-set-edit/brands-predefined-set-edit.modal.js";
import "../hmodules/brands-predefined-sets/modals/brands-predefined-set-save/brands-predefined-set-save.modal.js";
import "../hmodules/brands-predefined-sets/components/h-predefined-sets-brand-navigator/h-predefined-sets-brand-navigator.component.js";

import "../hmodules/on-boarding/services/on-boarding.service.js";
import "../hmodules/on-boarding/components/transfer-employee-button/transfer-employee-button.component.js";
import "../hmodules/on-boarding/components/change-employee-position-button/change-employee-position-button.component.js";
import "../hmodules/on-boarding/modals/change-employee-position/change-employee-position.modal.js";
import "../hmodules/on-boarding/modals/receipt-rules/receipt-rules.modal.js";
import "../hmodules/on-boarding/modals/transfer-employee/transfer-employee.modal.js";

import "../hmodules/par-labor/par-labor.module.js";
import "../hmodules/par-labor/services/par-labor-data.services.js";
import "../hmodules/par-labor/components/par-labor-main-list/par-labor-main-list.component.js";
import "../hmodules/par-labor/components/manage-par-labor/manage-par-labor.component.js";

import "../hmodules/authority-to-recruit/services/authority-to-recruite-data.service.js";

import "../hmodules/talent-scout/containers/talent-scout-redirection/talent-scout-redirection.container.js";
import "../hmodules/hyper-hire/controllers/manage-lists/manage-lists.js";
import "../hmodules/hyper-hire/components/job-distributor-component/job-sponsor/job-sponsor.modal.js";
import "../hmodules/hyper-hire/services/social-referral-settings.service.js";
import "../hmodules/career-story-page/containers/career-portal-story/career-story-page.container.js";
import "../hmodules/career-story-page/utils/font-family.utils.js";

import "../scripts/services/harri.auth.social.js";

import "../modules/progressTracker/scripts/progressTracker.js";
import "../modules/progressTracker/scripts/progressTrackerDirective.js";

import "../modules/ams/scripts/factories/amsApi.js";

import "../modules/ams/scripts/amsBus.js";
import "../modules/ams/modals/message_candidate/MessageCandidateModal.js";
import "../modules/ams/modals/skip_reasons/SkipModalController.js";
import "../modules/ams/modals/manage_lane_templates/ManageLaneTemplatesModal.js";

import "../modules/e-verify/e-verify.js";
import "../modules/e-verify/components/start-e-verify/start-e-verify.js";
import "../modules/e-verify/components/cases-statuses/cases-statuses.js";
import "../modules/e-verify/components/knowledge-test-certified-process/knowledge-test-certified-process.js";
import "../modules/e-verify/components/duplicate-cases/duplicate-cases.js";

import "../modules/rejection-templates/rejection-templates.js";
import "../modules/rejection-templates/components/manage-modal/manage-modal.js";
import "../modules/rejection-templates/components/rejection-templates-settings/rejection-templates-settings.js";
import "../modules/rejection-templates/components/manage-templates-form/manage-templates-form.js";

import "../modules/training/e-verify/scripts/EVerifyTestController.js";
import "../modules/training/e-verify/scripts/EVerifyTrainingController.js";
import "../modules/training/e-verify/scripts/EVerifyHeaderDirective.js";
import "../modules/hforms/ams_message_candidate/AMSMessageCandidateForm.js";
import "../modules/hforms/ams_manage_lane_templates/AMSManageLaneTemplatesForm.js";
import "../modules/hforms/ams_request_right_to_work_form/AMSRequestRightToWorkForm.js";
import "../modules/hforms/manage_eeo_forms/ManageEEOFormsForm.js";

import "../modules/on_boarding/modals/non_candidates_docs_modal/OBNonCandidatesDocsModal.js";
import "../modules/on_boarding/modals/custom_documents/OBCustomDocumentsModal.js";
import "../modules/on_boarding/modals/employment-reverification/employment-reverification.modal.js";
import "../modules/on_boarding/modals/wage-matrix-birthdate/wage-matrix-birthdate.modal.js";
import "../modules/on_boarding/modals/wage-matrix-failed-prospects/wage-matrix-failed-prospects.modal.js";

import "../modules/on_boarding/forms/employment-reverification/employment-reverification.form.js";

import "../modules/docs/scripts/utils/i9-reverification.js";
import "../modules/docs/scripts/utils/docsUtils.js";

import "../modules/speedy_screen/scripts/SSFactory.js";
import "../modules/speedy_screen/scripts/SSDirective.js";
import "../modules/speedy_screen/scripts/speedyX.js";
import "../modules/speedy_screen/components/video-reviewer/video-reviewer.component.js";
import "../modules/speedy_screen/forms/video-reviewer/video-reviewer.form.js";
import "../modules/speedy_screen/components/candidate-notes/candidate-notes.component.js";
import "../modules/speedy_screen/components/carri-chat/carri-chat.component.js";
import "../modules/speedy_screen/components/profile-matching/profile-matching.component.js";
import "../modules/speedy_screen/components/profile-matching-card/profile-matching-card.component.js";
import "../modules/speedy_screen/services/candidate-notes-data.service.js";

import "../modules/speedy_screen/components/tags-manager/tags-manager.component.js";
import "../modules/speedy_screen/components/candidate-tags-manager/candidate-tags-manager.component.js";
import "../modules/speedy_screen/components/candidate-tags-listing/candidate-tags-listing.component.js";

import "../modules/speedy_screen/services/tags-data.service.js";
import "../modules/speedy_screen/services/tags-events-data.service.js";

import "../hmodules/talent-pool/factories/colors-helper.factory.js";
import "../hmodules/talent-pool/modals/add-global-tag/add-global-tag.modal.js";
import "../hmodules/talent-pool/forms/add-global-tag/add-global-tag.form.js";
import "../hmodules/talent-pool/forms/assign-tags-to-candidates/assign-tags.form.js";
import "../hmodules/talent-pool/modals/invite-to-apply/invite-to-apply.modal.js";
import "../hmodules/talent-pool/services/talent-pool-data.service.js";
import "../hmodules/talent-pool/forms/invite-to-apply-message/invite-to-apply-message.form.js";
import "../hmodules/talent-pool/components/brand-job-selector/brand-job-selector.component.js";
import "../hmodules/talent-pool/modals/assign-tags-to-candidates/assign-tags-to-candidates.modal.js";
import "../hmodules/talent-pool/components/search-pages-navigator/search-pages-navigator.component.js";
import "../hmodules/talent-pool/services/invite-to-apply-data.service.js";
import "../hmodules/talent-pool/modals/add-note-to-candidates/add-note-to-candidates.modal.js";

import "../modules/chat/scripts/chatDirectives.js";
import "../modules/chat/scripts/chatFactory.js";
import "../modules/chat/scripts/candMsgsController.js";


import "../modules/media_viewer/scripts/mediaViewerController.js";
import "../modules/media_viewer/scripts/mediaViewerDirectives.js";
import "../modules/media_viewer/scripts/mediaViewerData.js";

import "../modules/job_apply/scripts/JobApplyController.js";
import "../modules/job_apply/scripts/VideoAnswerDirective.js";
import "../modules/job_apply/scripts/FarJobModalController.js";

import "../modules/hforms/manage_availability/scripts/ManageAvailabilityForm.js";
import "../modules/hforms/invite_to_interview/scripts/InviteToInterviewForm.js";
import "../modules/interview-calendar/scripts/interviewCalendar.js";
import "../modules/interview/scripts/InterviewController.js";
import "../modules/interview/scripts/InterviewDirectives.js";

import "../modules/interview/scripts/InterviewActionsModalController.js";
import "../modules/interview-v2/interview-v2.js";
import "../modules/interview-v2/interview-calendar-v2/interview-calendar-v2.js";
import "../modules/interview-v2/interview-calendar-v2/calendar/scripts/InterviewDataService.js";
import "../modules/interview-v2/interview-calendar-v2/calendar/scripts/InterviewViewService.js";
import "../modules/interview-v2/interview-calendar-v2/calendar/scripts/InterviewDragDropService.js";
import "../modules/interview-v2/interview-availability/interview-availability.js";
import "../modules/interview-v2/interview-availability/InterviewAvailabilityForm.js";
import "../modules/hforms/openday_details_form/scripts/OpenDayDetailsForm.js";
import "../modules/interview-v2/interview-invite/InterviewInviteModalController.js";
import "../modules/interview-v2/interview-invite/interview-calendar-form/InterviewCalendarForm.js";
import "../modules/interview-v2/interview-invite/interview-open-day-form/InterviewOpenDayForm.js";
import "../modules/interview-v2/interview-invite/interview-settings-form/InterviewSettingsForm.js";
import "../modules/interview-v2/interview-status-modal/InterviewStatusModalController.js";
import "../modules/interview-v2/interview-manage-availability/InterviewManageAvailability.js";
import "../modules/interview-v2/interview-manage-availability/interview-manage-availability-modal/InterviewManageAvailabilityModalController.js";
import "../modules/hforms/job_manifest/scripts/JobManifestModalController.js";
import "../modules/hforms/openday_details/scripts/OpenDayDetailsModalController.js";

import "../modules/offer/scripts/OfferController.js";

import "../modules/candidate_card/scripts/searchCandidateDirective.js";

import "../modules/forms/scripts/registrationDirectives.js";

import "../modules/forms/components/formElementWrapper/formElementWrapper.js";

import "../modules/forms/components/SharingWidget/SharingWidget.js";
import "../modules/forms/components/SharingWidget/sharing-widget.service.js";

import "../modules/forms/components/upload/upload.js";

import "../modules/chart/scripts/HChart.js";
import "../modules/chart/scripts/DonutChartDirective.js";

import "../modules/on_boarding/scripts/EmployerSignDocumentsController.js";

import "../modules/screening/scripts/ScreeningController.js";

import "../modules/social_referral/scripts/SocialReferralInvitationController.js";

import "../modules/search/scripts/searchFiltersController.js";
import "../modules/search/scripts/searchDirective.js";
import "../modules/search/scripts/factories/searchBackend.js";
import "../modules/search/scripts/shortlistController.js";
import "../modules/profiles/scripts/shortlistDirective.js";


import "../modules/settings/scripts/settingsController.js";
import "../modules/settings/scripts/settingsFactory.js";

import "../modules/user_media/scripts/userMediaController.js";

import "../modules/job_create/scripts/jobCreateDirectives.js";

import "../modules/job_profile/scripts/jobProfileController.js";
import "../modules/job_profile/scripts/JobDetailsBusFactory.js";
import "../modules/job_profile/scripts/previewJobProfileController.js";
import "../modules/job_profile/scripts/preview-job-post.service.js";


import "../modules/billing/utils/PaymentStripe.js";
import "../modules/billing/scripts/PaymentFactories.js";
import "../modules/billing/scripts/CreditsAPIs.js";

import "../modules/emp_quick_reg/scripts/EmployerQuickRegisterModalController.js";

import "../modules/profiles/scripts/memberProfilesController.js";
import "../modules/profiles/scripts/brandProfilesController.js";
import "../modules/profiles/scripts/ClaimProfileController.js";
import "../modules/profiles/scripts/MemberInviteToApplyController.js";
import "../modules/profiles/scripts/GPCareerPortalController.js";
import "../modules/profiles/scripts/CareerPortalDataBusFactory.js";
import "../modules/profiles/scripts/PremiumProfileController.js";
import "../modules/profiles/modals/gp-career-portal-filters/gp-career-portal-filters.modal.js";
import "../modules/profiles/modals/get-job-alerts/get-job-alerts.modal.js";
import "../modules/profiles/modals/gp-multiple-apply/gp-multiple-apply.modal.js";
import "../modules/profiles/modals/remove-job/remove-job.modal.js";
import "../modules/profiles/modals/apply-warning/apply-warning.modal.js";
import "../modules/profiles/modals/get-social-links/get-social-links.modal.js";
import "../modules/profiles/forms/get-job-alerts.form.js";
import "../modules/profiles/forms/multiple-apply-wizard/multiple-apply-wizard.form.js";
import "../modules/profiles/forms/select-jobs/select-jobs.form.js";
import "../modules/profiles/scripts/brand-profile-data-bus.service.js";


import "../modules/job_alerts/preferences/job-alert-preferences.controller.js";
import "../modules/job_alerts/subscription/job-alert-subscription.controller.js";

import "../modules/calculator/scripts/CalculatorController.js";
import "../modules/cost-saving/scripts/CostSavingController.js";

import "../modules/client_portal/scripts/clientPortalController.js";
import "../modules/client_portal/scripts/likeDislikeDirective.js";
import "../modules/client_portal/scripts/candidateTags.js";

import "../modules/iframe_full_page/scripts/IframeController.js";
import "../modules/landing_pages/scripts/LandingPageController.js";
import "../scripts/global/landing-pages.utils.js";


import "../hmodules/lms/modals/lms-welcome-modal/lms-welcome.modal.js";
import "../hmodules/lms/modals/lms-compliance-modal/lms-compliance.modal.js";
import "../hmodules/lms/modals/lms-contact-us-modal/lms-contact-us.modal.js";
import "../hmodules/lms/modals/lms-contact-us-modal/lms-contact-us.form.js";

import "../hmodules/wotc/modals/wotc/wotc.modal.js";

import "../scripts/apis/registrationApi.js";
import "../scripts/apis/jobApplyApi.js";

import "../apis/PositionsAPI.js";
import "../apis/WorkHistoryAPI.js";
import "../apis/WorkflowAutomationAPI.js";
import "../apis/AvailabilityAPI.js";
import "../apis/LiveScheduleAPI.js";
import "../apis/AvailabilityMatrixAPI.js";
import "../apis/OnBoardingAPI.js";
import "../apis/EVerifyAPI.js";
import "../apis/ThoughtSpotAnalyticsAPI.js";
import "../apis/JobDistributorAPI.js";

import "../apis/ReferenceAPI.js";
import "../apis/JobApplicationAPI.js";
import "../apis/TimeGeographyAPI.js";
import "../apis/ClientPortalAPI.js";
import "../apis/NotesAPI.js";
import "../apis/DashboardAPI.js";
import "../apis/UserApplicationsAPI.js";
import "../apis/MemberAPI.js";
import "../apis/RecommendationAPI.js";
import "../apis/SettingsAPI.js";
import "../apis/SkillsAPI.js";
import "../apis/InterviewAPI.js";
import "../apis/InterviewV2API.js";
import "../apis/InterviewVideoAPI.js";
import "../apis/CareerPortalAPI.js";
import "../apis/SubscriptionAPI.js";
import "../apis/LightSignUpAPI.js";
import "../apis/EEOAPI.js";
import "../apis/ProfileAPI.js";
import "../apis/ReportingAPI.js";
import "../apis/ReportingManagementAPI.js";
import "../apis/ReportingSettingsManagementAPI.js";
import "../apis/SpecialEventsAPI.js";
import "../apis/GoodMorningToolEngineAPI.js";
import "../apis/JobAPI.js";
import "../apis/ShiftsAPI.js";
import "../apis/DemoRequestAPI.js";
import "../apis/PerformanceAPI.js";
import "../apis/WeatherAPI.js";
import "../apis/CustomLanesAPI.js";
import "../apis/GPSAPI.js";
import "../apis/ATRAPI.js";
import "../apis/EmployeeNotesAPI.js";
import "../apis/TalentAssessmentAPI.js";
import "../apis/ThriveMapAssessmentAPI.js";
import "../apis/TalentPoolAPI2.js";
import "../apis/ActivityBasedSchedulingAPI.js";
import "../apis/ReportsAPI.js";
import "../apis/QuestionBankAPI.js";
import "../apis/PermissionsAPI.js";
import "../apis/StripeAPI.js";
import "../apis/ParLaborAPI.js";
import "../apis/GoogleTranslationAPI.js";
import "../apis/MinorSchedulingAPI.js";
import "../apis/FairSchedulingAPI.js";
import "../apis/MinimumMinorAgeAPI.js";
import "../apis/PaymentAPI.js";
import "../apis/ProfileMatchingAPI.js";
import "../apis/candidateAPI.js";
import "../apis/HarriEngageAPI.js";

import "../modules/team_schedule/employer/shifts/scripts/JobTitlesForm.js";
import "../modules/team_schedule/employer/schedule/scripts/TSViewEmployeeScheduleController.js";

import "../modules/hforms/team_schedule/employer/scripts/TSEmployerSettingsForm.js";

import "../modules/team_schedule/employer/roles/scripts/EditRolesForm.js";
import "../modules/team_schedule/employer/contact-info/scripts/EditContactInfoForm.js";
import "../modules/team_schedule/employer/ADPDetails/scripts/ADPDetailsDirective.js";

import "../modules/team_schedule/employer/par-labor/ParLaborController.js";
import "../modules/team_schedule/employer/manage-par-labor/ManageParLaborController.js";
import "../modules/team_schedule/employer/manage-par-labor/modals/load-from-template/load-from-template.modal.js";
import "../modules/team_schedule/employer/manage-par-labor/modals/save-as-template/save-as-template.form.js";

import "../scripts/harriApp.js";

import "../hmodules/user-activation/user-activation.module.js";
import "../hmodules/user-activation/user-activation.routes.js";
import "../hmodules/user-activation/modals/user-activation-success/user-activation-success.modal.js";
import "../hmodules/user-activation/modals/email-activation/email-activation.modal.js";
import "../hmodules/user-activation/modals/email-verification/email-verification.modal.js";
import "../hmodules/user-activation/services/user-activation.service.js";
import "../hmodules/user-activation/components/h-email-verification/h-email-verification.component.js";
import "../hmodules/user-activation/forms/email-activation/email-activation.form.js";

import "../scripts/services/hUserLocation.js";
import "../scripts/services/user.js";

import "../modules/hforms/signup/scripts/SignUpForm.js";
import "../modules/hforms/sign-up-social-links/scripts/SignUpSocialLinksForm.js";
import "../modules/hforms/add_email_form/AddEmailForm.js";
import "../modules/hforms/personal_information/scripts/PersonalInformationForm.js";
import "../modules/hforms/education/scripts/EducationForm.js";
import "../modules/hforms/experience/scripts/ExperienceForm.js";
import "../modules/hforms/references/scripts/ReferencesForm.js";
import "../modules/hforms/skills/scripts/SkillsForm.js";
import "../modules/hforms/brand_questions/scripts/BrandQuestionsForm.js";
import "../modules/hforms/signature/scripts/SignatureForm.js";
import "../modules/hforms/send_offer/scripts/SendOfferForm.js";
import "../modules/hforms/bulk_hire/BulkHireForm.js";
import "../modules/hforms/start_hiring/StartHiringForm.js";

import "../modules/hforms/invite_to_interview/scripts/InviteToInterviewForm.js";
import "../modules/hforms/manage_availability/scripts/ManageAvailabilityForm.js";

import "../modules/hforms/light_signup/scripts/LightSignUpForm.js";
import "../modules/hforms/light_signup/scripts/LightSignUpDirective.js";

import "../modules/hforms/candidate_onboarding/scripts/constants/NATIONALITY_CODES.js";
import "../modules/hforms/candidate_onboarding/scripts/constants/US_States.js";
import "../modules/hforms/candidate_onboarding/scripts/constants/countries.js";
import "../modules/hforms/candidate_onboarding/scripts/constants/Docs_Issuing_Auth.js";

import "../modules/hforms/candidate_onboarding/scripts/IdentityDocumentForm.js";
import "../modules/hforms/employer_onboarding/scripts/I9EmployerForm.js";


import "../modules/hforms/add_non_candidate/scripts/AddNonCandidateForm.js";
import "../modules/hforms/ncandidates_docs_form/scripts/NCandidatesDocsForm.js";

import "../modules/hforms/basic_info/scripts/BasicInfoForm.js";
import "../modules/hforms/resume_upload/scripts/ResumeUploadForm.js";
import "../modules/hforms/application_document_upload/scripts/ApplicationDocumentUploadForm.js";
import "../modules/hforms/work_eligibility/scripts/WorkEligibilityForm.js";
import "../modules/hforms/availability/scripts/AvailabilityForm.js";
import "../modules/hforms/screening_answer/scripts/ScreeningAnswerForm.js";
import "../modules/hforms/verified_location/scripts/VerifiedLocationForm.js";
import "../modules/hforms/job_preferred_location/scripts/JobPreferredLocationForm.js";
import "../modules/hforms/availability_matrix/scripts/AvailabilityMatrixForm.js";
import "../modules/hforms/profile_photo/scripts/ProfilePhotoForm.js";
import "../modules/hforms/job_apply_disclaimer/scripts/JobApplyDisclaimerForm.js";
import "../modules/hforms/disclaimer_form/scripts/disclaimerForm.js";

import "../modules/hforms/eeo_form/scripts/EmployerEEOForm.js";

import "../modules/sso/sso_login/sso-login.controller.js";
import "../modules/sso/sso_redirect/sso-redirect.controller.js";

import "../modules/team_schedule/employer/contact-info/scripts/EmployeeContactInfoDirective.js";
import "../modules/team_schedule/employer/contact-info/scripts/EditContactInfoForm.js";
import "../modules/team_schedule/employer/roles/scripts/EmployeeRolesDirective.js";
import "../modules/team_schedule/employer/employee-dropdown/scripts/EmployeeDropdownDirective.js";

import "../modules/team_schedule/employer/notifications/scripts/TLNotificationsModalController.js";
import "../modules/hmap/report-scheduler/modals/scheduled-exports.modal.js";
import "../modules/hmap/report-scheduler/forms/scheduled-exports.form.js";

import "../modules/hmap/report-scheduler/factories/scheduled-exports.factory.js";
import "../modules/hmap/report-scheduler/components/list-schedule-exports/list-schedule-exports.component.js";

import "../modules/team_schedule/employer/clock_time/modals/ct_edit_shift_modal/CTEditShiftModalController.js";
import "../modules/team_schedule/employer/clock_time/forms/ct_manage_shift_form/CTManageShiftForm.js";
import "../modules/team_schedule/employer/schedule/modals/schedule-premiums/schedule-premiums.modal.js";

import "../modules/dashboard/scripts/ScheduleDemoModalController.js";

import "../modules/hmap/hmap_layout_header/HMAPLayoutHeaderDirective.js";

import "../modules/hmap/dashboard/HMAPDashboardController.js";
import "../modules/hmap/my_jobs/JobAssigneesActionsModalController.js";
import "../modules/hmap/raw-data-reporting/HMAPRawDataReportingController.js";
import "../modules/hmap/atrs_listings/HMAPAtrsListingsController.js";
import "../modules/hmap/atrs_manage/HMAPAtrsManageController.js";


import "../modules/hmap/settings/Forms/hmap_general_settings_form/HMAPGeneralSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_media_settings_form/HMAPMediaSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_rejection_templates_settings_form/HMAPRejectionTemplatesSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_social_referral_notifications_settings_form/HMAPSocialReferralNotificationsSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_custom_sources_settings_form/HmapCustomSourcesSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_background_checks_settings_form/HMAPBackgroundChecksSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_positions_settings_form/HMAPPositionsSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_communication_hub_settings_form/HMAPCommunicationHubSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_job_approval_flow_settings_form/HMAPJobApprovalFlowSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_branded_comms_settings_form/HMAPBrandedCommsSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_communication_emails_settings_form/HMAPCommunicationEmailsSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_minimum_minor_age_settings_form/HMAPMinimumMinorAgeSettingsForm.js";
import "../modules/hmap/settings/Forms/hmap_documents_default_fields_settings_form/HMAPDocumentsDefaultFieldsSettingsForm.js";
import "../modules/hmap/hmapService.js";
import "../modules/hmap/services/hmap-ui.service.js";

import "../hmodules/restricted-positions/services/positions-data.service.js";


import "../modules/upload_applicants/modals/upload_applicant/UploadApplicantModal.js";
import "../modules/upload_applicants/forms/upload_applicant/UploadApplicantForm.js";
import "../modules/on_boarding/modals/good_faith_estimate_schedule/services/GoodFaithEstimateScheduleDataService.js";
import "../modules/on_boarding/modals/good_faith_estimate_schedule/modals/EditGoodFaithEstimateShiftsModalController.js";
import "../modules/on_boarding/modals/good_faith_estimate_schedule/forms/EditGoodFaithEstimateShiftsFormController.js";
import "../modules/on_boarding/modals/i9_resend_options/I9ResendOptionsModal.js";

import "../scripts/global-directives/request-demo-2020/request-demo-2020.modal.js";
import "../scripts/global-directives/landing-pages-modal/landing-pages.modal.js";

import "../modules/global_search_results/GlobalSearchResultController.js";

import "../modules/talent_assessment/modals/send_ceb_assessment/SendCEBAssessmentModal.js";
import "../modules/talent_assessment/forms/send_ceb_assessment/SendCEBAssessmentForm.js";
import "../modules/talent_assessment/modals/ceb_assessment_status/CEBAssessmentStatusModal.js";

import "../modules/team_schedule/employer/settings/constants/break_rules_constants.js";

import "../hmodules/lms/modals/lms-promo-modal/lms-promo.modal.js";

import "../hmodules/differential-pay-management/constants/differential-pay-management.constant.js"

import "../hmodules/pos-integration/modals/send-to-pos/send-to-pos.modal.js";
import "../hmodules/pos-integration/forms/send-to-toast/send-to-toast.form.js";
import "../modules/settings/modals/phone-verification-by-employee/phone-verification-by-employee.modal.js";

import "../modules/404page/scripts/PageNotFoundController.js";
import "../modules/team_schedule/employer/reports/constants/employee-edits-report.constants.js"
import "../modules/team_schedule/employer/settings/constants/overtime.constants.js"

import "../scripts/globalFactories/h-socket.factory.js";
import "../apis/NotificationManagerAPI.js";
import "../apis/OnBoardingJourneyAPI.js";
import "../apis/UpskillAPI.js";
import "../apis/OperatingHoursAPI.js";
import "../apis/UserPreferencesManagerAPI.js";
import "../apis/CoreHRPositionHierarchyAPI.js";
import "../apis/RestrictedPositionAPI.js";
import "../hmodules/harri-main/services/resizing-management.service.js";
import "../hmodules/work-visas/services/work-visas.service.js";
import "../hmodules/work-restrictions/services/work-restrictions.service.js";
import "../hmodules/components/h-brands-list-toggle/h-brands-list-toggle.component.js";
import "../hmodules/components/h-range-picker/h-range-picker.component.js";
import "../hmodules/directives/draggable-item/draggable-item.directive.js";
import "../hmodules/dashboards/services/dashboards-prerequisite.service.js";



import "../hmodules/harri-main/services/platform-navigator.service.js";
import "../hmodules/harri-main/services/google-search.service.js";
import "../hmodules/harri-main/services/user-preferences-manager.service.js";
import "../hmodules/pms/services/pms-general-settings.service.js";
import "../modules/settings/modals/talent-scout-share/talent-scout-share.modal.js";
import "../hmodules/source-hire-layout/containers/source-hire-layout.container.js";


import "../hmodules/harri-main/ui-components/hui-nav-wrapper.js";
import "../hmodules/harri-main/ui-components/hui-nav.js";
import "../hmodules/harri-main/ui-components/hui-nav-head.js";
import "../hmodules/harri-main/ui-components/hui-empty-result.js";
import "../hmodules/harri-main/ui-components/hui-nav-section.js";
import "../hmodules/harri-main/ui-components/hui-nav-item.js";
import "../hmodules/harri-main/ui-components/hui-nav-badge.js";

import "../hmodules/harri-main/factories/use-nav.factory.js";
import "../hmodules/navigation/factories/use-wfm-nav.factory.js";
import "../hmodules/navigation/factories/use-reports-nav.factory.js";
import "../hmodules/navigation/factories/use-dashboards-nav.factory.js";
import "../hmodules/navigation/factories/use-talent-nav.factory.js";
import "../hmodules/navigation/factories/use-platform-nav.factory.js";

import "../modules/speedy_screen/modals/position-tags-feedback/position-tags-feedback.modal.js";

import "../modules/search/controllers/custom-job-search/custom-job-search.controller.js";


import "../apis/PMSAPI.js";

import "../apis/WorkRestrictionAPI.js";
import "../modules/hforms/eeo-questions-candidate/eeo-questions-candidate.form.js";
import "../modules/team_schedule/employer/clock_time/modals/view-remote-clock-attempts/view-remote-clock-attempts.modal.js";
import "../hmodules/career-story-page/services/career-story-page.service.js";
import "../hmodules/harri-main/services/user-businesses.service.js";

import "../apis/GoodMorningToolEngineAPI.js";
import "../hmodules/components/h-icon-picker/h-icon-picker.component.js";
import "../hmodules/components/h-icon-picker/services/icon-picker.service.js";
import "../hmodules/components/h-icon-dropdown/h-icon-dropdown.component.js";
import "../hmodules/components/h-icon-picker/factories/use-icon-picker.factory.js";
import "../hmodules/career-story-page/utils/font-family.utils.js";
import "../modules/hforms/sign-up-social-links/scripts/SignUpSocialLinksForm.js";
import "../modules/team_schedule/employer/clock_time/services/employerPaySheet.service.js";

import "../modules/team_schedule/employer/settings/forms/minor-work-rules-settings/constants/minor-work-rules.constants.js"

import "../core/harri.js";

if (window.customerTagManagerId) {
    HThirdPartyManager.register(HStoragePolicyManager.Categories.ANALYTICS, function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${window.customerTagManagerId}`;
        document.head.appendChild(script);
    });
}

if (window.clickIqSnippet) {
    HThirdPartyManager.register(HStoragePolicyManager.Categories.ANALYTICS, function() {
        const script = document.createElement('script');
        script.src = 'https://api.clickiq.co.uk/scripts/4.0/tracking.js';
        document.head.appendChild(script);
    });
}

